import ko from '@tko/build.knockout';
import baguetteBox from '../../thirdPartyForks/baguetteBox';


ko.bindingHandlers.baguetteBox = {
  init: function (element, valueAccessor) {
    ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
      baguetteBox.hide();
    });
  },

  update: function(element, valueAccessor) {
    // Optional parameters passed from the view
    ko.unwrap(valueAccessor());

    // Re-run baguetteBox to attach click handlers to new DOM nodes
    setTimeout(function() {
      baguetteBox.hide();

      baguetteBox.run("." + Array.from(element.classList).join("."), {
        captions: false,
        animation: false,
        noScrollbars: true,
        filter: /.+\.(gif|jpe?g|png|webp|svg)/i,
        cycle: true,
        leftArrow: '<svg width="44" height="60">' +
          '<polyline points="30 10 10 30 30 50" stroke="rgba(255,255,255,0.5)" stroke-width="4"' +
          'stroke-linecap="round" fill="none" stroke-linejoin="round"/>' +
          '</svg>',
        rightArrow: '<svg width="44" height="60">' +
          '<polyline points="14 10 34 30 14 50" stroke="rgba(255,255,255,0.5)" stroke-width="4"' +
          'stroke-linecap="round" fill="none" stroke-linejoin="round"/>' +
          '</svg>',
        closeX: '<svg width="30" height="30">' +
          '<g stroke="rgba(255,255,255,0.5)" stroke-width="4">' +
          '<line x1="5" y1="5" x2="25" y2="25" stroke-linecap="round"/>' +
          '<line x1="5" y1="25" x2="25" y2="5" stroke-linecap="round"/>'
      });
    }, 0);
  }
};
